import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { NgxJsonLdModule } from "@ngx-lite/json-ld";

import { CommonsModule } from "../../commons/commons.module";

import { ProductComponent } from "./product.component";
import { DetailComponent } from "./detail/detail.component";
import { ListComponent } from "./list/list.component";

export const routes: Routes = [
  {
    path: "search",
    component: ListComponent,
    data: {
      title: "search",
      breadcrumb: [
        {
          label: "Home",
          url: "/",
        },
        {
          label: "Search",
          url: "",
        },
      ],
    },
  },
  {
    path: ":name/:id",
    component: DetailComponent,
    data: {
      title: "detail",
      breadcrumb: [
        {
          label: "Home",
          url: "/",
        },
        {
          label: "Detail",
          url: "",
        },
      ],
    },
  },
];

@NgModule({
  imports: [
    CommonModule,
    CommonsModule,
    RouterModule.forChild(routes),
    FormsModule,
    NgxJsonLdModule,
  ],
  declarations: [ProductComponent, ListComponent, DetailComponent],
})
export class ProductModule {}
